module.exports = __webpack_public_path__ + "img/lobby_index_bg.c90e195d.png";